import React, {useMemo, useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import classNames from './Leads.module.css'
import Button from '@mui/material/Button';
import TablePagination from '@mui/material/TablePagination';
import {Layout} from '../components/common/Layout';
import {GET_LEADS} from "../api/lead/getLeads";
import {useMutation, useQuery} from '@apollo/client';
import {INVITE_LEAD} from "../api/lead/inviteLead";
import {ErrorMessage} from "../components/common/ErrorMessage";

const PER_PAGE = 10

export const Leads = () => {
    const [currentPage, setCurrentPage] = useState(0)

    const [isSnackBarOpen, setIsSnackBarOpen] = useState(false)

    const options = useMemo(() => {
        return ({
            variables: {
                offset: currentPage * PER_PAGE,
                limit: PER_PAGE
            }
        })
    }, [currentPage])

    const {loading: isFetchLoading, data, refetch} = useQuery(GET_LEADS, options);

    const [inviteLead, {error, loading: isEditLoading}] = useMutation(INVITE_LEAD)

    const onButtonClick = async (id: string) => {
        const {errors} = await inviteLead({variables: {leadId: id}})

        if (errors === undefined || errors.length === 0) {
            await refetch({
                offset: currentPage * PER_PAGE,
                limit: PER_PAGE
            })
        } else {
            setIsSnackBarOpen(true)
        }
    }

    const isLoading = isFetchLoading || isEditLoading

    return (
        <Layout
            isLoading={isLoading}
            showHeader
            showMenu
            title="Leads"
        >
            {data !== undefined && (
                <>
                    <TableContainer component={Paper}>
                        <Table className={classNames.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Company</TableCell>
                                    <TableCell>Industry</TableCell>
                                    <TableCell>Country</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.getLeads.leads.map((row) => (
                                    <TableRow key={row.id} className={classNames.row}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.company}</TableCell>
                                        <TableCell>{row.industry}</TableCell>
                                        <TableCell>{row.country}</TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.phone}</TableCell>
                                        <TableCell>
                                            <Button
                                                onClick={() => onButtonClick(row.id)}
                                                size="small"
                                                variant="contained"
                                            >
                                                Send
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        count={data.getLeads.totalCount}
                        onPageChange={(event, page) => setCurrentPage(page)}
                        page={currentPage}
                        rowsPerPage={PER_PAGE}
                        rowsPerPageOptions={[]}
                    />
                </>
            )}

            <ErrorMessage
                handleClose={() => setIsSnackBarOpen(false)}
                isOpen={isSnackBarOpen}
                message={error?.message}
            />
        </Layout>
    )
}
